var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

export { commonjsGlobal };
//# sourceMappingURL=_virtual-_commonjsHelpers.js.map
